<template>
  <div class="calendar-viewer">
    <div
      v-for="month in monthsToRender"
      :key="month.year + '-' + month.month"
      class="calendar-viewer__month"
    >
      <div class="calendar-viewer__header">
        <span class="calendar-viewer__title">
          {{ month.monthName }} {{ month.year }}
        </span>
      </div>
      <div class="calendar-viewer__grid">
        <div
          class="calendar-viewer__weekday"
          v-for="day in weekDays"
          :key="day"
        >
          {{ day }}
        </div>
        <div
          v-for="n in month.firstDayOfWeek"
          :key="'empty-' + n"
          class="calendar-viewer__cell calendar-viewer__cell--empty"
        ></div>
        <div
          v-for="day in month.daysInMonth"
          :key="day"
          :class="cellClass(month.year, month.month, day)"
        >
          {{ day }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
function getMonthName(year, month) {
  return new Date(year, month - 1).toLocaleString("es-ES", { month: "long" });
}
function getDaysInMonth(year, month) {
  return new Date(year, month, 0).getDate();
}
function getFirstDayOfWeek(year, month) {
  const day = new Date(year, month - 1, 1).getDay();
  return day === 0 ? 6 : day - 1;
}
function parseDate(str) {
  // "YYYY-MM-DD" => Date
  const [y, m, d] = str.split("-").map(Number);
  return new Date(y, m - 1, d);
}
function formatDate(year, month, day) {
  return (
    year +
    "-" +
    String(month).padStart(2, "0") +
    "-" +
    String(day).padStart(2, "0")
  );
}

export default {
  name: "CalendarViewer",
  props: {
    startDate: { type: String, required: true },
    endDate: { type: String, required: true },
    customDatesOne: { type: Array, default: () => [] },
    customDatesTwo: { type: Array, default: () => [] },
  },
  computed: {
    weekDays() {
      return ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];
    },
    monthsToRender() {
      const start = parseDate(this.startDate);
      const end = parseDate(this.endDate);
      const months = [];
      let year = start.getFullYear();
      let month = start.getMonth() + 1;
      while (
        year < end.getFullYear() ||
        (year === end.getFullYear() && month <= end.getMonth() + 1)
      ) {
        const daysInMonth = getDaysInMonth(year, month);
        const firstDayOfWeek = getFirstDayOfWeek(year, month);
        months.push({
          year,
          month,
          monthName: getMonthName(year, month),
          daysInMonth,
          firstDayOfWeek,
        });
        month++;
        if (month > 12) {
          month = 1;
          year++;
        }
      }
      return months;
    },
    startDateObj() {
      return parseDate(this.startDate);
    },
    endDateObj() {
      return parseDate(this.endDate);
    },
    customDatesOneSet() {
      return new Set(this.customDatesOne);
    },
    customDatesTwoSet() {
      return new Set(this.customDatesTwo);
    },
  },
  methods: {
    cellClass(year, month, day) {
      const dateStr = formatDate(year, month, day);
      let classes = ["calendar-viewer__cell"];
      // Verificar si el día está habilitado
      const current = parseDate(dateStr);
      let enabled = current >= this.startDateObj && current <= this.endDateObj;
      if (!enabled) {
        classes.push("calendar-viewer__cell--disabled");
        return classes;
      }
      if (this.customDatesOneSet.has(dateStr)) {
        classes.push("calendar-viewer__cell--custom-one");
      } else if (this.customDatesTwoSet.has(dateStr)) {
        classes.push("calendar-viewer__cell--custom-two");
      }
      return classes;
    },
  },
};
</script>

<style src="./calendarViewer.scss" scoped lang="scss"></style>
